import * as utils from '../utils/utils.js';

export function anonAuthenticated(eventAccessKey, user) {
    if (user === null) {
        return false;
    }

    const cookieName = 'VCL.EmailAuthenticated-' + eventAccessKey;
    const rx = new RegExp('^(.*;)?\\s*' + cookieName + '\\s*=\\s*[^;]+(.*)?$');
    const cookieExists = rx.test(document.cookie);
    const localStorageVal = localStorage.getItem(cookieName);
    
    return cookieExists || localStorageVal;
}

export function pageLoadConfirmed(eventAccessKey, user) {
    if (user === null) {
        return false;
    }

    let cookieName = 'VCL.PageLoadConfirmed-' + eventAccessKey;
    var rx = new RegExp('^(.*;)?\\s*' + cookieName + '\\s*=\\s*[^;]+(.*)?$');

    return rx.test(document.cookie);
}

export function pinAuthenticated(eventAccessKey) {
    let cookieName = 'VCL.PINAuthenticated-' + eventAccessKey;
    var rx = new RegExp('^(.*;)?\\s*' + cookieName + '\\s*=\\s*[^;]+(.*)?$');

    return rx.test(document.cookie);
}

export function isAnonymous(user) {
    return user !== null && !user._au;
}

export function aadAuthenticated(user) {
    return user !== null && user._ij !== undefined && user._ij.length > 0;
}

export function allowedToSeeEventAdminLinks(user, eventAdmins) {
    if (user === null) return false;

    return user._sf === true || (eventAdmins && eventAdmins.indexOf(user._ik) >= 0);
}

export function allowedToSeeTechnicianLinks(user) {
    if (user === null) return false;

    return user._sf === true || user._tn === true;
}

export function allowedToSeeAdminUILinks(user) {
    if (user === null) return false;

    return allowedToSeeTechnicianLinks(user) || user._ae === true;
}

export function hasElevatedEventPermissions(user, eventAdmins) {
    if (user === null) return false;

    return (
        allowedToSeeEventAdminLinks(user, eventAdmins) ||
        allowedToSeeTechnicianLinks(user) ||
        user._vw === true
    );
}

export function getSignInUrlIfUserNotAuthenticated(
    user,
    eventAccessType,
    verifyPinLogin,
    eventAdmins,
    signInRequiredForExternalUsers
) {
    if (siteSettings.isEmbeddedPage) {
        // AAD authentication is not needed in embed mode, this is handled on CDN level
        if (
            (!eventAccessType.requireFedAuth &&
                signInRequiredForExternalUsers &&
                !aadAuthenticated(user) &&
                !anonAuthenticated(pageContext.accessKey, user)) ||
            (verifyPinLogin &&
                eventAccessType.requirePin &&
                !pinAuthenticated(pageContext.accessKey) &&
                !hasElevatedEventPermissions(user, eventAdmins))
        ) {
            return utils.getSignInUrl(false, null, pageContext.accessKey, true);
        } else {
            return null;
        }
    } else {
        if (
            // Verify federated login
            (eventAccessType.requireFedAuth || siteSettings.requireOrgSignIn) &&
            !aadAuthenticated(user)
        ) {
            return utils.getSignInUrl(true);
        } else if (
            signInRequiredForExternalUsers &&
            !aadAuthenticated(user) &&
            !anonAuthenticated(pageContext.accessKey, user)
        ) {
            // Verify anonymous login
            utils.log('watch', 'Sign in required for anonymous user, redirecting...', true, 1);
            return utils.getSignInUrl(false, null, pageContext.accessKey, false);
        } else if (
            verifyPinLogin &&
            eventAccessType.requirePin &&
            !pinAuthenticated(pageContext.accessKey) &&
            !hasElevatedEventPermissions(user, eventAdmins)
        ) {
            // We know the user does not need to authenticate externally since we've already checked that.
            // Perform PIN login
            return utils.getSignInUrl(false, null, pageContext.accessKey, false);
        } else return null; // User is authenticated
    }
}
